import Route from '@ember/routing/route';
import { service } from '@ember/service';
import type FastApiService from 'walden-fast/services/fast-api';
import type { Invoice } from 'walden-fast/types/invoice';
import type {
  PaginatedResponse,
  PaginationQueryParams,
  SortingQueryParams,
} from 'walden-fast/types/pagination';
import { getSortingParams } from 'walden-fast/utils/sorting';

type Resolved<P> = P extends Promise<infer T> ? T : P;

export type AppManageSubscriptionsInvoicesRouteModel = Resolved<
  ReturnType<AppManageSubscriptionsInvoicesRoute['model']>
>;

type AppManageSubscriptionsInvoicesRouteQueryParams = SortingQueryParams &
  PaginationQueryParams;

export default class AppManageSubscriptionsInvoicesRoute extends Route {
  @service('fast-api') declare fastApiService: FastApiService;

  queryParams = {
    page: {
      refreshModel: true,
    },
    pageSize: {
      refreshModel: true,
    },
    sortField: {
      refreshModel: true,
    },
    sortDirection: {
      refreshModel: true,
    },
  };

  async model(params: AppManageSubscriptionsInvoicesRouteQueryParams) {
    const response = await this.fastApiService.get<PaginatedResponse<Invoice>>(
      '/invoices',
      {
        page: params.page || 1,
        pageSize: params.pageSize || 10,
        ...getSortingParams(params),
      },
    );
    if (!response) {
      throw new Error(`No invoices returned from API`);
    }
    return {
      invoices: response,
    };
  }
}
